export type WaitlistStatus = 'OPEN' | 'OFFERED' | 'CONVERTED' | 'EXPIRED' | 'CANCELLED';

export const WAITLIST_STATUS_LABEL: Record<WaitlistStatus, { label: string; tone: string }> = {
    OPEN: { label: 'Open', tone: 'open' },
    OFFERED: { label: 'Offered', tone: 'offered' },
    CONVERTED: { label: 'Converted', tone: 'paid' },
    EXPIRED: { label: 'Expired', tone: 'muted' },
    CANCELLED: { label: 'Cancelled', tone: 'danger' },
};

export type WaitlistPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';

/** Priority metadata — used for the badge color + sort order. Numerical
 *  weight gives lower-number = higher importance for sort comparisons. */
export const WAITLIST_PRIORITY_LABEL: Record<WaitlistPriority, { label: string; tone: string; weight: number }> = {
    CRITICAL: { label: 'Critical', tone: 'critical', weight: 0 },
    HIGH:     { label: 'High',     tone: 'high',     weight: 1 },
    MEDIUM:   { label: 'Medium',   tone: 'medium',   weight: 2 },
    LOW:      { label: 'Low',      tone: 'low',      weight: 3 },
};

export interface WaitlistEntry {
    id: string;
    businessId: string;
    clientId?: string | null;
    customerName?: string | null;
    customerPhone?: string | null;
    customerEmail?: string | null;
    teamMemberId?: string | null;
    serviceIds: string[];
    /** YYYY-MM-DD. */
    validUntil?: string | null;
    priority: WaitlistPriority;
    /** Candidate slot the staff picked. ISO local datetime. */
    desiredStartTime?: string | null;
    desiredEndTime?: string | null;
    preferredTimes?: string | null;
    notes?: string | null;
    status: WaitlistStatus;
    convertedAppointmentId?: string | null;
    createdBy?: string | null;
    createdOn?: string | null;
    updatedOn?: string | null;
}

export interface WaitlistEntryInput {
    id?: string | null;
    businessId: string;
    clientId?: string | null;
    customerName?: string | null;
    customerPhone?: string | null;
    customerEmail?: string | null;
    teamMemberId?: string | null;
    serviceIds?: string[] | null;
    validUntil?: string | null;
    priority?: WaitlistPriority | null;
    desiredStartTime?: string | null;
    desiredEndTime?: string | null;
    preferredTimes?: string | null;
    notes?: string | null;
    status?: WaitlistStatus | null;
}
